const roomFilter = {
  filters: [
    {
      id: 1,
      name: "All Categories",
      filterData: "filter-item",
    },
    {
      id: 2,
      name: "Category 1",
      filterData: "cat1",
    },
    {
      id: 3,
      name: "Category 2",
      filterData: "cat2",
    },
    {
      id: 4,
      name: "Category 3",
      filterData: "cat3",
    },
    {
      id: 5,
      name: "Category 4",
      filterData: "cat4",
    },
  ],
  projects: [
    {
      id: 1,
      image: "/landing/img/luxury/luxury-1.jpg",
      title: "Resource1",
      price: "134",
      class_s: "col-xl-3 col-lg-4 mt-30",
      filter: ["cat1"],
    },
    {
      id: 2,
      image: "/landing/img/luxury/luxury-2.jpg",
      title: "Resource2",
      price: "199",
      class_s: "col-xl-6 col-lg-8 mt-30",
      filter: ["cat2"],
    },
    {
      id: 3,
      image: "/landing/img/luxury/luxury-3.jpg",
      title: "Resource3",
      price: "319",
      class_s: "col-xl-3 col-lg-4 mt-30",
      filter: ["cat3"],
    },
    {
      id: 4,
      image: "/landing/img/luxury/luxury-4.jpg",
      title: "Resource4",
      price: "169",
      class_s: "col-xl-6 col-lg-8 mt-30",
      filter: ["cat4"],
    },
    {
      id: 5,
      image: "/landing/img/luxury/luxury-5.jpg",
      title: "Resource5",
      price: "249",
      class_s: "col-xl-6 mt-30",
      filter: ["cat4"],
    },
  ],
};

export default roomFilter;
